
import { defineComponent } from 'vue';
import api from '@/api/my/serviceCodes';
import utils from '@/utils';
import QRCode from 'qrcode';
import { IHost } from '@/types/models';

interface IPayForm {
  channel: string;
  isPurchased: boolean;
  isQrCode: boolean;
  orderNo: string;
  failureCount: 0;
}

interface IState {
  active: string;
  hosts: IHost[];
  price: number;
  payForm: IPayForm;
}

export default defineComponent({
  name: 'Buy',
  emits: ['close'],
  data() {
    return {
      active: 'apply',
      hosts: [],
      price: 0,
      payForm: {} as IPayForm,
    } as IState;
  },
  methods: {
    apiGet() {
      this.active = 'apply';
      this.hosts = [];
      this.price = 0;
      this.payForm = {} as IPayForm;

      api.buy((res) => {
        if (!res) return;
        this.hosts = res.hosts;
        this.price = res.price;
      });
    },

    getUrl(hostName: string, nodeName: string, isHongKong: boolean): string {
      return utils.getHostUrl(hostName, nodeName, isHongKong);
    },

    getUniqueName(host: IHost) {
      return utils.getHostUniqueName(host);
    },

    getHostType(host: IHost) {
      return utils.getHostType(host.hostType);
    },

    getPayAmount(): number {
      return this.price;
    },

    getChannel() {
      return this.payForm.channel === 'AliPay' ? '支付宝' : '微信';
    },

    getPayDescription() {
      const amount = this.getPayAmount().toFixed(2);
      return `
        费用合计:
        <span style="color: #fa5300">￥${amount}</span>`;
    },

    payQuery() {
      const interval = setInterval(() => {
        api.query(
          {
            orderNo: this.payForm.orderNo,
          },
          (res) => {
            this.payForm.isPurchased = res.isPurchased;

            if (this.payForm.isPurchased) {
              clearInterval(interval);
            }
          },
        );
      }, 3000);
    },

    btnHostClick(host: IHost) {
      utils.alertDelete(
        {
          title: '申请ICP备案服务码',
          text: '此操作将申请ICP备案服务码，ICP备案服务码有效期为15天，确定吗？',
          button: '确定申请',
        },
        () => {
          api.apply({ hostId: host.id }, (res) => {
            if (res.value) {
              this.active = 'applySuccess';
            }
          });
        },
      );
    },

    btnPayChannelClick(channel: string) {
      this.payForm.channel = channel;

      api.pay(
        {
          channel: this.payForm.channel,
          amount: this.getPayAmount(),
        },
        (res) => {
          if (!res) return;

          this.payForm.isQrCode = true;
          this.payForm.orderNo = res.orderNo;

          setTimeout(() => {
            QRCode.toCanvas(document.getElementById('qrcode'), res.qrCodeUrl, { width: 260 });
          }, 100);

          this.payQuery();
        },
        (error) => {
          console.log(error);
          this.payForm.failureCount += 1;
          if (this.payForm.failureCount < 3) {
            this.btnPayChannelClick(channel);
          } else {
            utils.loading(false);
            utils.error(error);
          }
        },
      );
    },

    btnPayClick() {
      this.active = 'pay';
      this.payForm.failureCount = 0;
    },

    btnCloseClick() {
      this.$emit('close');
    },
  },
  mounted() {
    this.apiGet();
  },
});
